import { createFileRoute } from '@tanstack/react-router';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';

import { OfferManagement } from '~/features/leadDetails/components/Overview/OfferManagement';
import {
    acceptedOffersQueryOptions,
    aclPermissionsQueryOptions,
} from '~/features/leadDetails/routes/acceptedOffersQueryOptions';
import {
    type OfferManagementSearch,
    offerManagementSearchSchema,
} from '~/features/leadDetails/schemas/offerManagementSearch.schema';

export const Route = createFileRoute('/_app/leads_/details/$leadId/offer-management')({
    component: OfferManagement,
    loader: async ({ context, deps, params }) => {
        const permissions = await context.queryClient.ensureQueryData(aclPermissionsQueryOptions(params.leadId));
        const canGetAcceptedOffers =
            permissions.resolvers[AGGREGATE_NAMES.LOAN_REQUEST][LOAN_REQUEST_RESOLVERS.getAcceptedOffers];

        if (!canGetAcceptedOffers) return [];

        return context.queryClient.ensureQueryData(
            acceptedOffersQueryOptions({
                filter: deps.offerFilter,
                leadId: params.leadId,
            }),
        );
    },
    loaderDeps: ({ search }: { search: OfferManagementSearch }): OfferManagementSearch => ({
        offerFilter: search.offerFilter,
    }),
    validateSearch: offerManagementSearchSchema,
});
